import { App } from 'vue'

import SidebarTrigger from './SidebarTrigger.vue'
import UiClickOutside from './UiClickOutside.vue'
import Table from './Table.vue'
import AllSelectionController from './AllSelectionController.vue'
import UiDropdown from './UiDropdown.vue'
import Loader from './Loader.vue'
import Burger from './Burger.vue'
const register = (app: App<Element>): void => {
  app
  .component('AllSelectionController', AllSelectionController)
  .component('SidebarTrigger', SidebarTrigger)
  .component('UiClickOutside', UiClickOutside)
  .component('UiTable', Table)
  .component('Loader', Loader)
  .component('UiDropdown', UiDropdown)
  .component('UiBurger', Burger)
}

export default {
  register,
}
